<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-bring-backward`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4h26a2 2 0 012 2v8h8a2 2 0 012 2v26a2 2 0 01-2 2H16a2 2 0 01-2-2v-8H6a2 2 0 01-2-2V6a2 2 0 012-2zm24 14H18v22h22V18H30z"/></svg>
</template>
<script>

export default {
  name: 'IconBringBackward',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
